import type { Course } from '@yandex-int/k-common';
import { getCourses } from '@yandex-int/k-common/client/api';
// @ts-ignore
import { showNetworkError } from 'platform-components/src/components/notification/actions';
import { call, put, takeEvery, all } from 'redux-saga/effects';

import {
    getTeacherCoursesByClassError,
    getTeacherCoursesByClassRequest,
    getTeacherCoursesByClassSuccess,
} from './actions';
import { GET_TEACHER_COURSES_BY_CLASS_REQUEST } from './constants';

export function* teacherCoursesByClassSagasWatcher() {
    yield all([takeEvery(GET_TEACHER_COURSES_BY_CLASS_REQUEST, getTeacherCoursesByClassSaga)]);
}

function* getTeacherCoursesByClassSaga(action: ReturnType<typeof getTeacherCoursesByClassRequest>) {
    const { classIds } = action;

    try {
        const courses: Course[] = yield call(getCourses);
        yield put(getTeacherCoursesByClassSuccess(classIds, courses));
    } catch (error) {
        console.error(error);
        yield put(getTeacherCoursesByClassError(classIds));
        yield put(showNetworkError(error));
    }
}
